import { Box } from '@mui/material';
import styled from 'styled-components';

const NullStateDiv = styled(Box)`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  width: 100%;
  padding: 40px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.text.secondary};
  min-height: 140px;
  box-sizing: border-box;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => theme.palette.grey.A200};
  border-radius: 8px;
  box-shadow: inset 0 0 10px ${({ theme }) => theme.palette.grey['300']};
  row-gap: 5px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    margin: 0 auto;
  }
`;

export default NullStateDiv;
